import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ButtonModule } from '../../common/button/button.module';
import { DropdownModule } from './../../common/dropdown/dropdown.module';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { CheckboxModule } from './../../forms/checkbox/checkbox.module';
import { BulkSelectComponent } from './bulk-select.component';

@NgModule({
  declarations: [BulkSelectComponent],
  exports: [BulkSelectComponent],
  imports: [
    ButtonModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    I18nModule,
    RtUICoreOverlayModule,
  ],
})
export class BulkSelectModule {}
export { BulkSelectComponent } from './bulk-select.component';
